import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"; 
import Home from "./components/home";  
import Details from "./components/details"; 
import "./index.css"
import "./App.css"


const App = () => {
  return (
    <Router>
    <Routes>
      <Route path="/*" element={<Home />} />
     <Route path="/details/:id" element={<Details />} />
     </Routes>
  </Router>
  );
};

export default App;
